import { createFileRoute } from "@tanstack/react-router";

import RoomConfigPage from "@/pages/room-config-page";

export const Route = createFileRoute("/room-config/$room/$config-name")({
  component: () => <Component />,
});

function Component() {
  const { room, "config-name": configName } = Route.useParams();

  return <RoomConfigPage room={room} config={configName} />;
}
